
//import { requirePropFactory } from '@material-ui/core';
import React from 'react';
import ReactDOM from 'react-dom';
import {Form, FormControl, Button} from 'react-bootstrap'
require('./search.css')
/*
  This class contains all script about the search bar and redirect to corresponding page
*/
interface ISearchBarState {
    inputValue : string
    keyEnter : boolean
}

class SearchBar extends React.Component<{}, ISearchBarState> {

      constructor(props: any) {
        super(props);
           
        this.state = {
          inputValue: '',
          keyEnter: false
        };

        this.onInputChange = this.onInputChange.bind(this);
      }

      // WEIRD
      handleKeyPress = (event: any) => {
        if(event.charCode === 13){
          window.location.href = 'https://privasee.netlify.app/clauses?site=' + this.state.inputValue;
          event.preventDefault();
        }
      }

      public render() {

        return (
           	<Form inline> 
              <FormControl id="search-field-css" type="text" placeholder="Ex: Facebook..." className="mr-sm-2" onKeyPress={this.handleKeyPress} onChange={this.onInputChange}/>
              <Button id="search-button-css" href={"/clauses?site=" + this.state.inputValue} variant="outline-primary">Analyser</Button>
            </Form>
        );          
    }

    private onInputChange(e: any) {
        const { value } = e.target;

        this.setState({
          inputValue: value
        });
      }
}


ReactDOM.render(<SearchBar />, document.getElementById('app'));
export default SearchBar;